/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
import ApiClient from "../api-client/apiClient";
// @ts-ignore
import { getAccessToken } from "../auth/index";
// @ts-ignore

import { handleIsLoading, handleListing } from "../store/general";
import { toast } from "react-toastify";
// filepath: /home/nitinb/Desktop/my_projects/Helios/react_changes19 (1)/react/src/actions/user.tsx

const apiUrl = process.env.REACT_APP_API_URL;
const version = process.env.REACT_APP_API_VERSION;

// ----------------------------------------------------------user API----------------------------------------------

/**
 * Fetch list of users
 * @param {any} data - Filters for fetching user list
 * @param {Function} callback - Callback function to handle response
 */
export const userListAction = (params: any, callback: any) => {
  return async (dispatch: any) => {
    const tokenRaw: any = getAccessToken();
    try {
      dispatch(handleIsLoading(true));
      if (tokenRaw) {
        const response: any = await ApiClient.get(
          `${apiUrl}${version}/admin/user`,
          // params?.params,
          params,
          dispatch
        );
        if (response.status === 200) {
          callback(response);
          dispatch(handleIsLoading(false));
        }
      }
    } catch (err) {
      if (err) {
        dispatch(handleIsLoading(false));
        callback(err);
        toast.error(err?.response?.message);
      }
    } finally {
      dispatch(handleIsLoading(false));
    }
  };
};

/**
 * Update user details
 * @param {any} data - Updated user details
 * @param {Function} callback - Callback function to handle response
 */
export const updateUserDetails = (data: any, callback: any) => {
  return async (dispatch: any) => {
    try {
      dispatch(handleIsLoading(true));
      dispatch(handleListing(true));
      const response = await ApiClient.patchFormData(
        `${apiUrl}${version}/user/update-profile`,
        data,
        dispatch
      );
      dispatch(handleIsLoading(false));
      if (response.status === 200 || response.status === 201) {
        toast.success(response.message);
        dispatch(handleIsLoading(false));
        return callback(response);
      }
    } catch (error) {
      callback(error);
      toast.error(error.response.data.message);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * Create a new user
 * @param {any} data - User details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const createUserForm = (data: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    try {
      dispatch(handleIsLoading(true));
      dispatch(handleListing(true));
      const response: any = await ApiClient.postFormData(
        `${apiUrl}${version}/admin/user`,
        data
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message || "User created successfully");
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      callback(error);
      toast.error(error?.data?.message);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * Update a existing user
 * @param {any} data - User details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const updateUserForm = (data: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    try {
      dispatch(handleIsLoading(true));
      dispatch(handleListing(true));
      // const response: any = await ApiClient.patchFormData(
      const response: any = await ApiClient.patchFormData(
        `${apiUrl}${version}/admin/user/${data?.id}`,
        data?.data
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message);
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      callback(error);
      toast.error(error?.data?.message);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * Delete a user by ID
 * @param {number} userId - The ID of the user to be deleted
 * @param {(response: any) => void} callback - Callback function to handle response
 * @returns {(dispatch: Dispatch) => void} - Redux Thunk function
 */
export const deleteUser = (userId: number, callback: any) => {
  return async (dispatch: any) => {
    try {
      dispatch(handleIsLoading(true));
      dispatch(handleListing(true));
      const response: any = await ApiClient.delete(
        `${apiUrl}${version}/admin/user/${userId}`,
        dispatch
      );
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message);
        dispatch(handleIsLoading(false));
        return callback(response);
      }
    } catch (error) {
      dispatch(handleIsLoading(false));
      callback(error);
      toast.error(error?.data?.message);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * Fetch list of organizations initially in organization listing
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const selectedUserList =
  (id: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/admin/user/${id}`,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Fetch admin dashboard data of users
 * @param {any} data - Filters for fetching user list
 * @param {Function} callback - Callback function to handle response
 */

export const getAdminDashboardData = (roleId) => {
  return async (dispatch: any) => {
    try {
      let endPoint = "/user/dashboard-data"; // Default value

      if (roleId === 1) {
        endPoint = "/admin/dashboard";
      } else if (roleId === 2 || roleId === 3) {
        endPoint = "/leader/dashboard";
      }
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}${endPoint}`,
        dispatch
      );

      if (response.status === 200) {
        dispatch(handleIsLoading(false));
        return response; // ✅ Return the response data
      }
    } catch (err) {
      // catch (err) {
      //   dispatch(handleIsLoading(false));
      //   return Promise.reject(err);
      // }
      // Ensure rejection is always an instance of Error
      const error = err instanceof Error ? err : new Error(String(err));
      return Promise.reject(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };
};

/**
 * Fetch elements assigned by its organization ID
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const getElementsByUserId =
  (data: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    const { params, userId } = data;
    try {
      dispatch(handleIsLoading(true));
      dispatch(handleListing(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/leader/organization/data-elements/${userId}`,
        params,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };

// -------------------------------------------------Organization API--------------------------------------------

/**
 * Create a new organization
 * @param {any} data - Organization details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const createOrganizationForm = (data: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    try {
      dispatch(handleIsLoading(true));
      dispatch(handleListing(true));
      const response: any = await ApiClient.postFormData(
        `${apiUrl}${version}/admin/organization`,
        data
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message);
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      callback(error);
      toast.error(error?.data?.message);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * Update a current organization
 * @param {any} data - Organization details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const updateOrganizationForm = (
  { data, id }: { data: any; id: number },
  callback: any
) => {
  return async (dispatch: any) => {
    try {
      dispatch(handleIsLoading(true));
      dispatch(handleListing(true));
      const response: any = await ApiClient.patchFormData(
        `${apiUrl}${version}/admin/organization/${id}`,
        data
      );
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message || "Organization updated successfully");
        callback(response);
      }
    } catch (error: any) {
      toast.error(error?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * Fetch elements assigned by its organization ID
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const getElementsOrganizationById =
  (data: any, callback: (response: any) => void) => async (dispatch: any) => {
    const { params, organizationId, roleId } = data || {};
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const endPoint =
        roleId === 2 || roleId == 3
          ? `/leader/assigned/data-elements/${organizationId}`
          : `/user/organization/data-elements/${organizationId}`;
      const response: any = await ApiClient.get(
        `${apiUrl}${version}${endPoint}`,
        params,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Fetch list of organizations initially in organization listing
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const selectedOrganizationList =
  (id: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/admin/organization/${id}`,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Fetch list of organizations
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const OrganizationListAction =
  (requestParams: any, callback: (response: any) => void) =>
  async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/admin/organization`,
        requestParams,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Fetch organization by its ID
 * @param {Function} callback - Callback function to handle response
 */
export const getOrganizationById =
  (organizationId: any, callback: (response: any) => void) =>
  async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/admin/organization/${organizationId}`,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Delete a organization by ID
 * @param {number} organizationId - The ID of the user to be deleted
 * @param {(response: any) => void} callback - Callback function to handle response
 * @returns {(dispatch: Dispatch) => void} - Redux Thunk function
 */
export const deleteOrganization = (organizationId: number, callback: any) => {
  return async (dispatch: any) => {
    dispatch(handleIsLoading(true));
    dispatch(handleListing(true));
    try {
      const response: any = await ApiClient.delete(
        `${apiUrl}${version}/admin/organization/${organizationId}`,
        dispatch
      );
      if (response.status === 200 || response.status === 201) {
        toast.success(response.message);
        return callback(response);
      }
    } catch (error) {
      console.log(error, "error");
      toast.error(error?.data?.message);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

// ---------------------------------------------------Category---------------------------------------------------

/**
 * Create a new category
 * @param {any} data - User details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const createCategoryForm = (data: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    dispatch(handleIsLoading(true));
    dispatch(handleListing(true));
    try {
      const response: any = await ApiClient.post(
        `${apiUrl}${version}/admin/category`,
        data
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message || "Category created successfully");
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * update a category
 * @param {any} data - budget details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const updateCategoryForm = (data: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    const { id, ...payload } = data;

    try {
      dispatch(handleIsLoading(true));
      dispatch(handleListing(true));
      const response: any = await ApiClient.patch(
        `${apiUrl}${version}/admin/category/${id}`,
        payload
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message || "Category updated successfully");
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * Fetch list of categories in the admin section
 * @param {any} data - Filters for fetching user list
 * @param {Function} callback - Callback function to handle response
 */
export const categoryList = (params: any, callback: any) => {
  return async (dispatch: any) => {
    const tokenRaw: any = getAccessToken();
    try {
      dispatch(handleIsLoading(true));
      if (tokenRaw) {
        const response: any = await ApiClient.get(
          `${apiUrl}${version}/admin/category-list`,
          params,
          dispatch
        );
        if (response.status === 200) {
          callback(response);
          dispatch(handleIsLoading(false));
        }
      }
    } catch (error) {
      if (error) {
        callback(error);
        toast.error(error.response.message);
      }
    } finally {
      dispatch(handleIsLoading(false));
    }
  };
};

/**
 * Fetch list of categories
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const categoryListAction =
  (params: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/admin/category-list`,
        params,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Fetch list of Category by id
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const selectedCategoryList =
  (id: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/admin/category/${id}`,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Delete a category by ID
 * @param {number} id - The ID of the category to be deleted
 * @param {(response: any) => void} callback - Callback function to handle response
 * @returns {(dispatch: Dispatch) => void} - Redux Thunk function
 */
export const deleteCategory = (id: number, callback: any) => {
  return async (dispatch: any) => {
    try {
      dispatch(handleIsLoading(true));
      dispatch(handleListing(true));
      const response: any = await ApiClient.delete(
        `${apiUrl}${version}/admin/category/${id}`,
        dispatch
      );
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message);
        dispatch(handleIsLoading(false));
        return callback(response);
      }
    } catch (error) {
      dispatch(handleIsLoading(false));
      callback(error);
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

// ------------------------------------------DataElement----------------------------------------------

/**
 * Create a new Data Element
 * @param {any} data - User details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const createDataElementForm = (data: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    dispatch(handleIsLoading(true));
    dispatch(handleListing(true));
    try {
      const response: any = await ApiClient.post(
        `${apiUrl}${version}/admin/data-element`,
        data
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message || "Data element created successfully");
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * update a  budget
 * @param {any} data - budget details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const updateDataElementForm = (payload: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    const { budgetId, ...data } = payload;
    dispatch(handleIsLoading(true));
    dispatch(handleListing(true));
    try {
      const response: any = await ApiClient.patch(
        `${apiUrl}${version}/admin/data-element/${budgetId}`,
        data
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message || "Budget created successfully");
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * Fetch list of data Elements
 * @param {any} data - Filters for fetching user list
 * @param {Function} callback - Callback function to handle response
 */
export const dataElementList =
  (data: any, callback: (response: any) => void) => async (dispatch: any) => {
    dispatch(handleIsLoading(true));
    try {
      const endPoint = "/admin/data-element-list"; // Default endpoint

      // If isBudget is 1, use queryData instead of params
      const queryData =
        data?.payload?.isBudget === 1
          ? { ...data?.payload?.params, isBudget: data?.payload?.isBudget }
          : data?.params;
      const response: any = await ApiClient.get(
        `${apiUrl}${version}${endPoint}`,
        queryData,
        dispatch
      );
      callback(response);
    } catch (error) {
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Fetch list of Data Element by id
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const selectedDataElementList =
  (id: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    dispatch(handleIsLoading(true));
    dispatch(handleListing(true));
    try {
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/admin/data-element/${id}`,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };

/**
 * Fetch list of data elements
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const dataElementsListAction =
  (params: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/admin/data-element-list`,
        params,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Delete a data element by ID
 * @param {number} elementId - The ID of the user to be deleted
 * @param {(response: any) => void} callback - Callback function to handle response
 * @returns {(dispatch: Dispatch) => void} - Redux Thunk function
 */
export const deleteDataElement = (elementId: number, callback: any) => {
  return async (dispatch: any) => {
    dispatch(handleIsLoading(true));
    dispatch(handleListing(true));
    try {
      const response: any = await ApiClient.delete(
        `${apiUrl}${version}/admin/data-element/${elementId}`,
        dispatch
      );
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message);
        return callback(response);
      }
    } catch (error) {
      callback(error);
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

// ------------------------------------------------Budgets-------------------------------------------------------------

/**
 * Create a new budget
 * @param {any} data - budget details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const createBudgetForm = (data: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    try {
      dispatch(handleIsLoading(true));
      dispatch(handleListing(true));
      const response: any = await ApiClient.post(
        `${apiUrl}${version}/admin/budget`,
        data
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message || "Budget created successfully");
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      toast.error(error?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * update a  budget
 * @param {any} data - budget details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const updateBudgetForm = (data: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    const { id, ...payload } = data;

    try {
      dispatch(handleIsLoading(true));
      dispatch(handleListing(true));
      const response: any = await ApiClient.patch(
        `${apiUrl}${version}/admin/budget/${id}`,
        payload
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message || "Budget Updated successfully");
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * Fetch list of budgets
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const budgetListAction =
  (params: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/admin/budget-list`,
        params,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Delete a Budget by ID
 * @param {number} id - The ID of the Budget to be deleted
 * @param {(response: any) => void} callback - Callback function to handle response
 * @returns {(dispatch: Dispatch) => void} - Redux Thunk function
 */
export const deleteBudget = (id: number, callback: any) => {
  return async (dispatch: any) => {
    try {
      dispatch(handleIsLoading(true));
      dispatch(handleListing(true));
      const response: any = await ApiClient.delete(
        `${apiUrl}${version}/admin/budget/${id}`,
        dispatch
      );
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message);
        dispatch(handleIsLoading(false));
        return callback(response);
      }
    } catch (error) {
      dispatch(handleIsLoading(false));
      callback(error);
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * Fetch list of budget by id
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const selectedBudgetList =
  (id: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/admin/budget/${id}`,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

export const submissionDataUpdateRequestListAction =
  (params: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/admin/submission/update/requests`,
        params,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

// ------------------------------------------Submission status-----------------------------

/**
 * Fetch list of submission status
 * @param {any} data - Filters for fetching submission list
 * @param {Function} callback - Callback function to handle response
 */
export const submissionListStatusAction = (payload: any, callback: any) => {
  return async (dispatch: any) => {
    const tokenRaw: any = getAccessToken();
    const { params, id } = payload;
    if (id) {
      params.categoryId = id;
    }
    try {
      dispatch(handleIsLoading(true));
      if (tokenRaw) {
        const response: any = await ApiClient.get(
          `${apiUrl}${version}/admin/submission-status`,
          params,
          dispatch
        );
        if (response.status === 200) {
          callback(response);
          dispatch(handleIsLoading(false));
        }
      }
    } catch (err) {
      if (err) {
        dispatch(handleIsLoading(false));
        callback(err);
        toast.error(err?.response?.message);
      }
    } finally {
      dispatch(handleIsLoading(false));
    }
  };
};

//--------------------------------------------change org leader/ controller-----------------------------

/**
 * Update the leader / controller of a org
 * @param {any} data - User details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const changeOrgLeaderController = (data: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    dispatch(handleIsLoading(true));
    dispatch(handleListing(true));
    try {
      const response: any = await ApiClient.post(
        `${apiUrl}${version}/admin/change-leader`,
        data
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message);
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      toast.error(error?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * Update the role of a user
 * @param {any} data - User details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const changeUserRole = (data: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    dispatch(handleIsLoading(true));
    dispatch(handleListing(true));
    try {
      const response: any = await ApiClient.post(
        `${apiUrl}${version}/admin/change-role`,
        data
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message);
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      toast.error(error?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};
